import { RedBullVersion } from "./redBullVersion";

export const getProductVersionContainsSugar = (version: RedBullVersion) => {
  switch (version) {
    case "original":
    case "edition": {
      return true;
    }
    case "zero":
    case "edition-sugarfree":
    case "sugarfree": {
      return false;
    }
    default: {
      /**
       * If you're getting a type-error here, then it's because a new
       * `redBullVersion` value has been added to the list of options, and you
       * need to add a `case` above to reflect whether or not it contains sugar.
       */
      version satisfies never;
      return false;
    }
  }
};
